module.exports = __webpack_public_path__ + "img/kurand_ec_partner_bnr2.67731d78.png";